"use strict";

exports.__esModule = true;
var _TimelineValue = require("./TimelineValue");
Object.keys(_TimelineValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimelineValue[key]) return;
  exports[key] = _TimelineValue[key];
});
var _ClassificationTimelineValue = require("./ClassificationTimelineValue");
Object.keys(_ClassificationTimelineValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassificationTimelineValue[key]) return;
  exports[key] = _ClassificationTimelineValue[key];
});
var _ShiftTimelineValue = require("./ShiftTimelineValue");
Object.keys(_ShiftTimelineValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ShiftTimelineValue[key]) return;
  exports[key] = _ShiftTimelineValue[key];
});